import React, {useState} from "react";
import {PhoneInput} from "react-international-phone";
import moment from "moment";
import {Input, SelectInput, TimeSelect} from "./FormsInput";
import {AddressInput} from "./AddressInput";
import {normalizeLocationName} from "../utils/location";
import {PickupDateInput} from "./PickupDate";
import "react-international-phone/style.css";
import toast from "react-hot-toast";
import {isLocationNotAcceptedWithoutArray} from "../utils/zone";

export const Type = [
  {label: "SME", value: "smes"},
  {label: "Corporate", value: "corporates"},
  {label: "Corporate above 1000", value: "corporates_above_1000"},
  {label: "International", value: "international"},
  {label: "Individual", value: "individuals"},
];

export const PickupDetails = ({
  handleBlur,
  handleChange,
  values,
  errors,
  touched,
  setStep,
  step,
  setFieldValue,
  setFieldTouched,
  initialValues,
}: {
  values: any;
  handleChange: any;
  handleBlur: any;
  touched: any;
  errors: any;
  step: number;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  setFieldValue: any;
  setFieldTouched: any;
  initialValues: any;
}) => {
  const [edit, setEdit] = useState(true);

  const validateAndProceed = () => {
    const requiredFields = [
      {name: "first_name", label: "first name"},
      {name: "last_name", label: "last name"},
      {name: "address", label: "address"},
      {name: "state", label: "state"},
      {name: "city", label: "city"},
      {name: "latitude", label: "latitude"},
      {name: "longitude", label: "longitude"},
    ];

    // Check basic required fields
    for (const field of requiredFields) {
      if (!values[field.name]) {
        toast.error(`Please fill in ${field.label}`);
        return false;
      }
      if (errors[field.name]) {
        toast.error(errors[field.name]);
        return false;
      }
    }

    // Check coordinates
    if (Number(values.latitude) <= 0 || Number(values.longitude) <= 0) {
      toast.error("Please select a valid address");
      return false;
    }

    // Check phone number
    if (!values.phone_number) {
      toast.error("Please enter a valid phone number");
      return false;
    }
    if (errors.phone_number) {
      toast.error(errors.phone_number);
      return false;
    }
    return true;
  };

  const handleContinue = () => {
    if (edit) {
      if (validateAndProceed()) {
        setEdit(false);

        // Your existing logic for setting delivery schedules
        if (
          values.pickupTime === "7am - 8:30am" &&
          values.accountType === "WITHIN_LAGOS"
        ) {
          values.deliveries.forEach((delivery: any, index: number) => {
            setFieldValue(`deliveries[${index}].d_schedule`, "Same Day");
          });
        } else if (
          values.pickupTime === "8:30am - 10am" &&
          values.accountType === "WITHIN_LAGOS"
        ) {
          values.deliveries.forEach((delivery: any, index: number) => {
            setFieldValue(`deliveries[${index}].d_schedule`, "Next Day");
          });
        } else if (values.accountType === "OUTSIDE_LAGOS") {
          values.deliveries.forEach((delivery: any, index: number) => {
            setFieldValue(
              `deliveries[${index}].d_schedule`,
              "3 - 5 Business Days"
            );
          });
        } else if (values.accountType === "OUTSIDE_NIGERIA") {
          values.deliveries.forEach((delivery: any, index: number) => {
            setFieldValue(
              `deliveries[${index}].d_schedule`,
              "5 - 7 Business Days"
            );
          });
        }
      }
    } else {
      setStep(2);
    }
  };

  return (
    <div className="!border !border-gray-400 !py-4 !px-8 !rounded-[20px] !mb-8 !relative">
      <div className="!flex !gap-2">
        <p className="!font-semibold !text-gray-700">Sender Details</p>
        {step > 1 && (
          <button
            onClick={() => {
              setStep(1);
              setEdit(true);
            }}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3 21L12 21H21"
                stroke="#36394A"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12.2218 5.8279L15.0503 2.99947L20 7.94922L17.1716 10.7776M12.2218 5.8279L6.61522 11.4345C6.42769 11.622 6.32233 11.8764 6.32233 12.1416L6.32233 16.6771L10.8579 16.6771C11.1231 16.6771 11.3774 16.5718 11.565 16.3842L17.1716 10.7776M12.2218 5.8279L17.1716 10.7776"
                stroke="#36394A"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        )}
      </div>
      <div className="!absolute !top-5 !right-6">
        {step < 2 ? (
          <svg
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="0.5"
              y="1"
              width="19"
              height="19"
              rx="9.5"
              fill="#F8FAFB"
            />
            <rect
              x="0.5"
              y="1"
              width="19"
              height="19"
              rx="9.5"
              stroke="#DFE1E7"
            />
          </svg>
        ) : (
          <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 2.5C6.5 2.5 2 7 2 12.5C2 18 6.5 22.5 12 22.5C17.5 22.5 22 18 22 12.5C22 7 17.5 2.5 12 2.5ZM10 17.5L5 12.5L6.41 11.09L10 14.67L17.59 7.08L19 8.5L10 17.5Z"
              fill="#287F6E"
            />
          </svg>
        )}
      </div>
      {step === 1 && (
        <>
          {edit ? (
            <div className="!grid !grid-cols-2 !gap-4 !mt-6">
              {/* First Name */}
              <Input
                type="name"
                name="first_name"
                label="First Name"
                placeholder="Enter first name"
                error={touched.first_name && errors.first_name}
              />
              {/* Last Name */}
              <Input
                type="name"
                name="last_name"
                label="Last Name"
                placeholder="Enter last name"
                error={touched.last_name && errors.last_name}
              />

              {/* Address */}
              <AddressInput
                name="address"
                label="Address"
                placeholder="Search your address"
                onPlaceSelected={(place) => {
                  console.log(place);
                  if (place.address_components) {
                    setFieldValue(
                      `city`,
                      place.address_components[5].long_name
                    );
                    setFieldValue(
                      `state`,
                      place.address_components[6].long_name
                    );
                    const rawLocation = place.address_components[5].long_name;
                    const normalizedLocation =
                      normalizeLocationName(rawLocation);

                    // Find matching location in your array
                    const matchedLocation = Type.find(
                      (loc) =>
                        loc.value === normalizedLocation ||
                        loc.label.toUpperCase() === normalizedLocation
                    );

                    if (matchedLocation) {
                      setFieldValue("location", matchedLocation.value);
                    } else {
                      //   toast.error(`Location not recognized: ${rawLocation}`);
                      //   setFieldValue("location", "IKEJA");
                    }
                  }
                  if (place.geometry?.location) {
                    setFieldValue("latitude", place.geometry.location.lat());
                    setFieldValue("longitude", place.geometry.location.lng());
                  } else {
                    console.warn("No geometry found in place object");
                  }
                }}
                onTimezoneOffsetFetched={(timezone) => {
                  setFieldValue("timezone", timezone);
                }}
              />

              {/* Phone Number */}
              <div className="!flex !flex-col !gap-1">
                <label
                  htmlFor="phone_number"
                  className="!text-sm !text-gray-600"
                >
                  Phone Number <span className="!text-red-500">*</span>
                </label>
                <PhoneInput
                  defaultCountry="ng"
                  value={values.phone_number}
                  disableDialCodeAndPrefix
                  onFocus={() => setFieldTouched("phone_number", true, true)}
                  onChange={(phone) => setFieldValue("phone_number", phone)}
                  onBlur={handleBlur}
                  className={` !rounded-lg !border !bg-white !h-12 !px-6 !flex !items-center !text-sm !text-gray-900 focus:!outline-none ${
                    !touched.phone_number && !errors.phone_number
                      ? "!border-gray-100"
                      : ""
                  } ${
                    touched.phone_number && !errors.phone_number
                      ? `!border-[#FE7F20] !shadow-[0px_0px_1px_3px_rgba(254,127,32,0.15)]`
                      : ""
                  } ${
                    errors.phone_number && touched.phone_number
                      ? `!border-[#DF1C41] !shadow-[0px_0px_1px_3px_rgba(223,28,65,0.15)]`
                      : ""
                  }`}
                  inputClassName={`!w-full !border-0 !p-0 !m-0 hover:!bg-transparent`}
                  countrySelectorStyleProps={{
                    buttonClassName:
                      "!border-0 !p-0 !m-0 hover:!bg-transparent",
                    dropdownStyleProps: {
                      className: "",
                    },
                  }}
                />
                {errors.phone_number && touched.phone_number && (
                  <div className="!flex !items-center !gap-1 !mt-1">
                    <svg
                      width="14"
                      height="15"
                      viewBox="0 0 14 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7 4.83333V7.5M7 10.1667H7.00667M1 7.5C1 8.28793 1.15519 9.06815 1.45672 9.7961C1.75825 10.5241 2.20021 11.1855 2.75736 11.7426C3.31451 12.2998 3.97595 12.7417 4.7039 13.0433C5.43185 13.3448 6.21207 13.5 7 13.5C7.78793 13.5 8.56815 13.3448 9.2961 13.0433C10.0241 12.7417 10.6855 12.2998 11.2426 11.7426C11.7998 11.1855 12.2417 10.5241 12.5433 9.7961C12.8448 9.06815 13 8.28793 13 7.5C13 5.9087 12.3679 4.38258 11.2426 3.25736C10.1174 2.13214 8.5913 1.5 7 1.5C5.4087 1.5 3.88258 2.13214 2.75736 3.25736C1.63214 4.38258 1 5.9087 1 7.5Z"
                        stroke="#DF1C41"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>

                    <p className="!text-xs !font-semibold !text-[#DF1C41]">
                      {errors.phone_number}
                    </p>
                  </div>
                )}
              </div>

              <Input
                type="email"
                name="email"
                label="Email"
                placeholder="Enter email"
                required={false}
                error={touched.email && errors.email}
              />

              {/* <SelectInput
                name="type"
                label={`Customer type`}
                options={Type}
                error={touched.type && errors.type}
              /> */}
            </div>
          ) : (
            <div className="!flex !items-center !justify-between !gap-6 !mt-8">
              <div className="!space-y-2">
                <p className="!font-semibold !text-gray-500 !text-base">
                  {values.first_name} {values.last_name}
                </p>
                <p className="!font-medium !text-gray-500 !text-sm">
                  {values.address}
                </p>
                <p className="!font-medium !text-gray-500 !text-sm">
                  {values.phone_number}
                </p>
              </div>
              <button
                onClick={() => {
                  setEdit(true);
                }}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3 21L12 21H21"
                    stroke="#36394A"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12.2218 5.8279L15.0503 2.99947L20 7.94922L17.1716 10.7776M12.2218 5.8279L6.61522 11.4345C6.42769 11.622 6.32233 11.8764 6.32233 12.1416L6.32233 16.6771L10.8579 16.6771C11.1231 16.6771 11.3774 16.5718 11.565 16.3842L17.1716 10.7776M12.2218 5.8279L17.1716 10.7776"
                    stroke="#36394A"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </div>
          )}

          <div className="!flex !justify-end !w-full !mt-6">
            {/* <Button
              className="bg-primary-0 text-[#fe7f1f] active:bg-primary-0"
              onClick={() => setStep(0)}
              type="button"
            >
              Go Back
            </Button> */}
            <button
              type="button"
              onClick={handleContinue}
              className={
                "!bg-[#fe7f1f]  !rounded-lg !text-white !text-sm !py-2 !px-4"
              }
            >
              Continue
            </button>
          </div>
        </>
      )}
    </div>
  );
};
